import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";

export class JubileeSevenFever_2Screen extends SlotGameType1_2Screen {
    //protected panelFactory: IPanelFactory = new JubileeSevenFeverPanelFactory();
    
    protected override helpFactory: IHelpFactory = new JubileeSevenFeverHelpFactory();

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "JubileeSevenFever");

        this.spinnableReelsParams.topBorderWidth = 10;
        this.spinnableReelsParams.bottomBorderWidth = 10;
    }

    //SEND COLOR FOR RSA 
    protected override color: RewardColor =
        {
            color: "#F1F0C9",
            coloroutherStroke: "black",
            colorinnerStroke: "#9F8DF4",
        }

}

//Panel Colorized
class JubileeSevenFeverPanelFactory implements IPanelFactory {
    public CreateNewPanel(params: PanelParams): Panel {
        return new JubileeSevenFeverPanel(params);
    }
}

class JubileeSevenFeverPanel extends Panel {
    protected override ButtonBackground(): ButtonColors {
        let color: ButtonColors = {
            backgroundButtonColor: "linear-gradient(rgb(30, 3, 41),rgb(102, 11, 140), rgb(159, 15, 255),rgb(102, 11, 140),rgb(30, 3, 41)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            linearColor: "linear-gradient(to left , transparent, rgb(255, 69, 230),transparent ) 0 10 100%",
        };
        return color;

    }

}
class JubileeSevenFeverHelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new JubileeSevenFeverHelp(params);
    }
}

class JubileeSevenFeverHelp extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(30, 3, 41),rgb(102, 11, 140), rgb(159, 15, 255),rgb(102, 11, 140),rgb(30, 3, 41)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}
